import routeTracker from './services/routeTracker';

// Only export public API
export * from './components/TrackedRoute';
export * from './types/api';

export default routeTracker;